import { createStore, applyMiddleware, combineReducers, Reducer } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import ReduxThunk from 'redux-thunk';
import { reducer as formReducer, FormStateMap } from 'redux-form';

import modal from './reducers/modal-reducer';
import { ModalState } from './types/redux/ModalTypes';
import settings from './reducers/settings-reducer';
import { SettingsState } from './types/redux/SettingsTypes';

import search from './reducers/search';
import basket from './reducers/basket';

export interface ApplicationState {
    modalReducer: ModalState;
    settingsReducer: SettingsState;
    search: any;
    basket: any;
    form: FormStateMap;
}

export const rootReducer: Reducer<ApplicationState> = combineReducers<ApplicationState>({
    modalReducer: modal,
    settingsReducer: settings,
    search,
    basket,
    form: formReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default createStore(rootReducer, composeWithDevTools(applyMiddleware(ReduxThunk)));
